import { render } from "./ActivityCodeValueForm.vue?vue&type=template&id=387146f3&ts=true"
import script from "./ActivityCodeValueForm.vue?vue&type=script&lang=ts"
export * from "./ActivityCodeValueForm.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__